import styled from 'styled-components';
import { FixedWidth } from 'ui/utility/fixedWidth';
import { pxToRem } from 'utils/convert';
import { heading3, spacing, colors, heading4, heading5, Body2 } from 'ui/theme';
import { PageHeader } from 'ui/pageHeader';
import { NavTabsList } from 'ui/tabsGroup';

export const IndexTitle = styled.h3`
  ${heading3};
`;

export const IntelligentInsightsSpacedPageHeader = styled(PageHeader)`
  margin-top: ${spacing.threeQuarter};
  margin-bottom: ${spacing.double};
`;

export const StyledTabGroupWrapper = styled.div`
  border-bottom: none;
`;

export const StyledNavListBackground = styled.div`
  background-color: ${colors.white};
`;
export const StyledNavTabList = styled(NavTabsList)`
  margin-left: -${pxToRem(10)};
  border-bottom: none;
`;

export const StyledTabContentBackground = styled.div`
  background-color: ${colors.backgroundSecondary};
  margin-left: -${spacing.double};
  margin-right: -${spacing.double};
  margin-bottom: -${spacing.double};
  padding-left: ${spacing.double};
  padding-right: ${spacing.double};
  min-height: ${pxToRem(1000)};
`;

export const ContainerStackedRow = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerSpacedBetween = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ContainerCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MainHeaderTimeRangeContainer = styled(ContainerCenter)`
  gap: ${spacing.half};
`;

export const IndexContainerHeader = styled.h4`
  ${heading4};
  margin-bottom: ${spacing.quarter};
`;

export const IntelligentInsightsHeader = styled.h5`
  ${heading5};
  display: flex;
  align-items: center;
  scroll-margin-top: ${spacing.plusHalf};
`;

export const MainContentFixedWidth = styled(FixedWidth)`
  & > div:not(:first-of-type) {
    margin-top: ${spacing.double};
  }
`;

export const MarginlessBody2 = styled(Body2)`
  margin: 0;
`;

export const Wrapper = styled.div`
  padding: ${spacing.x12} 0;
`;

export const DescriptionWrapper = styled.span`
  max-width: ${pxToRem(460)};
`;

export const IntelligentInsightsBackground = styled.div`
  background-color: ${colors.backgroundSecondary};
  padding: ${spacing.double} 0;
`;
